var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'Sale')?_c('order-items',{attrs:{"id":_vm.id}}):_vm._e(),(_vm.type === 'Hire')?_c('order-assemblies',{ref:"orderAssemblyComponent",attrs:{"id":_vm.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }